import React from 'react';
import { connect } from 'dva';

import { framework_tool, utils_tool, component_tool } from '@/tool'
import PropTypes from 'prop-types';
import { SubjectForm } from '@/components'
import { modelUtils } from "@/utils";
import createColumns from "./column"
let { WizContainer } = framework_tool;
let { WizCard, WizForm, WizSpin, WizRow, WizCol, WizButton } = component_tool
import { WizTableForm } from '@/containers/common'
let { checkStrLength, $$, Session, dateUtils } = utils_tool;
import { Spin } from 'antd'
import moment from 'moment';
class MessageTaskDetail extends WizContainer {

  componentName = 'MessageTaskDetail';

  constructor(props) {
    super(props);
    this.initTypeAndRecord();
  }

  /**
   * 初始化时根据record判断是新增还是编辑
   */
  initTypeAndRecord() {
    let record = {};
    if (this.props.location && this.props.location['record']) {
      record = this.props.location['record']
      Session.set('messageTaskDetail', record)
    } else {
      let pathname = this.props.location['pathname'];
      record = pathname === '/message/MessageTask/MessageTaskDetail' ? (Session.get('messageTaskDetail') || {}) : {}

    }
    this.modalVisible = false


    this.state = {
      record: record
    }
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/message/MessageTask/MessageTaskDetail') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('messageTaskDetail', initialValue)
      } else {
        initialValue = Session.get('messageTaskDetail') || {};
      }
    }
    if (initialValue.bizType != this.state.record.bizType) {
      this.setState({ record: initialValue })
    }
  }

  _componentDidMount() {
  }
  //新增成功返回列表信息页面
  _messageTaskSave(nextProps, nextState) {
    let { messageTaskSave } = nextProps
    if (messageTaskSave && messageTaskSave['success']) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/message/MessageTask');
      return true
    } else {
      wizNotice.error(messageTaskSave && messageTaskSave['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  propsAndStateOnChange = {
    //新增方法
    messageTaskSave: this._messageTaskSave.bind(this),
  }




  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    return fitterValues;
  }

  /**保存消息 */
  _saveMessageTask(values) {

  }

  _onSubmit = (e) => {
    this.doAction({
      path: "messageTask/save",
      payload: {
        key: "messageTaskSave",
        apiParams: {
          ...e
        }
      }
    });

  }
  _render() {

    const { title } = this.props;
    const { config, record } = this.state;
    let { messageTaskLoading } = this.props


    //let onSubmit = this._saveMessageTask.bind(this);
    let formProps = {
      ref: 'form',
      key: this.state.record.bizType || '', // ⭐如缓存路由需要刷新,必须加标识key
      columns: createColumns(this, config, record),
      onSubmit: this._onSubmit,
      record: null,
      //footer: this._renderFooter(),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }
    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={messageTaskLoading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { messageTask } = state;
  const messageTaskSave = modelUtils.getModelEntity(messageTask, "messageTaskSave");

  const load = modelUtils.getLoadingState(state, ['messageTask']);
  return {
    messageTaskSave,
    ...load
  }
};

export default connect(mapStateToProps)(MessageTaskDetail);
